function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.307 13.631c.482.494.962.906 1.37 1.224A1.75 1.75 0 006 17.75h5.999a1.75 1.75 0 001.331-2.886 13.33 13.33 0 001.36-1.202c1.23-1.251 2.559-3.144 2.559-5.512C17.25 3.64 13.547 0 9 0 4.453 0 .75 3.64.75 8.15c0 2.332 1.332 4.225 2.557 5.481zM9 1.5c-3.737 0-6.75 2.987-6.75 6.65 0 1.754 1.012 3.287 2.13 4.434a12.416 12.416 0 002.016 1.661l.007.005h5.198l.01-.006a11.978 11.978 0 002.01-1.634c1.115-1.133 2.129-2.666 2.129-4.46 0-3.663-3.013-6.65-6.75-6.65zM6 15.75h6a.25.25 0 110 .5H6a.25.25 0 110-.5z",
  fill: "#E9688A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 18.5a.75.75 0 000 1.5h7a.75.75 0 000-1.5h-7z",
  fill: "#E9688A"
})));